export default __webpack_public_path__ + "841b10fd2944965f3cc53a835be9dd94.svg";